




















import {Component, Prop, Vue} from 'vue-property-decorator';
    import {ActiveInject, ActiveProvide} from "@/support/reactive"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdsToolbar from "@/design-system/patterns/JdsToolbar.vue"

    /**
     * @status stable
     * @published 3.8.0
     * @changelog 3.8.0 Published.
     * @changelog 4.10.2 Switch to card design.
     */
    @Component({
        components: {JdsToolbar, JdsGlyph, JdsIcon}
    })
    export default class JdsActionBox extends Vue {
        @ActiveProvide('jds.button.type') buttonType = 'secondary';
        @Prop() icon!: string;
    }
